module.exports = __webpack_public_path__ + "static/media/BUSD-BNB.c0e3ff6d.svg";